import React from "react";
import { Button } from "antd";
import { useSignUp } from "hook/useAuth";
import { FcGoogle } from "react-icons/fc";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormGoogle = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleLoginWithGoogle } = useSignUp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button
      loading={loading}
      disabled={loading}
      block
      type="text"
      onClick={handleLoginWithGoogle}
      className="rounded-md border-[1px] border-gray-300 px-2 py-1"
      icon={
        <span className="anticon">
          <FcGoogle size={16} />
        </span>
      }
    >
      Đăng nhập với Google
    </Button>
  );
};
export default FormGoogle;
